import React, { useState, useEffect } from "react";
import SlideMenu from "../micro_components/SlideMenu";
import { useLocation, useHistory } from "react-router-dom";
import DevelopBook from "./DevelopBook";
import BookDataService from "../../services/BookService";
import BookResources from "./BookResources";
import MaterialAddBook from "../MaterialAddBook";

const Book = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [book, setBook] = useState({
    id: null,
    title: "",
    domain_id: null,
    language: "",
    active: null,
    commentary: "",
    score: "",
    difficulty: "",
  });
  const initialMode =
    new URLSearchParams(location.search).get("tab") || "details";
  const [mode, setMode] = useState(initialMode);
  const [isNew, setIsNew] = useState(true);

  useEffect(() => {
    const id = props.match.params.id;

    if (id) {
      BookDataService.get(id)
        .then((response) => {
          setBook(response.data);
          setIsNew(false);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get("tab");
    if (tabParam) {
      setMode(tabParam);
    }
  }, [location.search]);

  const updateQueryParams = (mode) => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("tab", mode);
    history.push({ search: queryParams.toString() });
  };

  return (
    <div>
      <SlideMenu
        initialMode={mode}
        changeMode={(word) => updateQueryParams(word)}
      />
      {mode === "develop" ? (
        <DevelopBook {...props} book={book} setBook={setBook} />
      ) : mode === "details" ? (
        <MaterialAddBook
          book={book}
          isNew={isNew}
          fromSlideBookId={props.match.params.id}
          fromSlide={true}
        />
      ) : mode === "resources" ? (
        <BookResources bookId={book.id} />
      ) : null}
    </div>
  );
};

export default Book;
